enum BoundaryLegendAggregationType {
  AVG = "avg",
  MAX = "max",
  MEDIAN = "median",
  MIN = "min",
  SUM = "sum",
  VALUE_COUNT = "value_count", // not present in the docs, but found in the wild
}

export default BoundaryLegendAggregationType;
